import React from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

import { DEAL_OPTION_NAME_COLUMN_MIN_WIDTH } from './constants';

export default function DealOptionsTableHeader() {
  return (
    <TableHead>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: 'grey.50',
            color: 'text.secondary',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell sx={{ width: 40 }} />
        <TableCell sx={{ minWidth: DEAL_OPTION_NAME_COLUMN_MIN_WIDTH }}>Deal Option Name</TableCell>
        <TableCell align="center" sx={{ width: 56 }}>
          Alloc.
        </TableCell>
        <TableCell align="center" sx={{ width: 90 }}>
          Max Extra Nights
        </TableCell>
        <TableCell align="right" sx={{ width: 130 }}>
          Cost
        </TableCell>
        <TableCell align="right" sx={{ width: 120 }}>
          Sell price
        </TableCell>
        <TableCell align="right" sx={{ width: 120 }}>
          Cost/Night
        </TableCell>
        <TableCell align="right" sx={{ width: 90 }}>
          Margin
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
